var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4004 19.7813H25.6V22.1123C26.349 20.7717 28.2698 19.5671 31.1552 19.5671C36.6866 19.5671 37.9998 22.2358 37.9998 27.1322V36.2004H32.3998V28.2473C32.3998 25.4589 31.6508 23.8864 29.744 23.8864C27.0994 23.8864 26.0004 25.5811 26.0004 28.246V36.2004H20.4004V19.7813Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7979 35.9862H16.3979V19.5671H10.7979V35.9862Z",
    fill: "#FDFDFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2002 14.213C17.2004 14.6354 17.1073 15.0537 16.9263 15.4435C16.7454 15.8333 16.4801 16.1868 16.146 16.4835C15.469 17.0891 14.5525 17.4281 13.598 17.426C12.6451 17.4254 11.7308 17.0873 11.0528 16.4848C10.7199 16.1871 10.4555 15.8331 10.2749 15.4433C10.0942 15.0535 10.0008 14.6354 10 14.213C10 13.36 10.378 12.5435 11.0542 11.9412C11.7316 11.3379 12.6463 10.9996 13.5994 11C14.5542 11 15.4698 11.3389 16.146 11.9412C16.8208 12.5435 17.2002 13.36 17.2002 14.213Z",
    fill: "#FDFDFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.23bddca19bb8be1c04720a62b9c64a56.svg";
export { ForwardRef as ReactComponent };